__turbopack_context__.v({
  "boxOne": "bento-rectangle-module-scss-module__S-YguW__boxOne",
  "boxOneContent": "bento-rectangle-module-scss-module__S-YguW__boxOneContent",
  "boxOneCopy": "bento-rectangle-module-scss-module__S-YguW__boxOneCopy",
  "buttons": "bento-rectangle-module-scss-module__S-YguW__buttons",
  "center": "bento-rectangle-module-scss-module__S-YguW__center",
  "heading": "bento-rectangle-module-scss-module__S-YguW__heading",
  "headingImage": "bento-rectangle-module-scss-module__S-YguW__headingImage",
  "headinggradient": "bento-rectangle-module-scss-module__S-YguW__headinggradient",
  "iconTextList": "bento-rectangle-module-scss-module__S-YguW__iconTextList",
  "iconTextListContainer": "bento-rectangle-module-scss-module__S-YguW__iconTextListContainer",
  "image": "bento-rectangle-module-scss-module__S-YguW__image",
  "imageContainer": "bento-rectangle-module-scss-module__S-YguW__imageContainer",
  "invertLayout": "bento-rectangle-module-scss-module__S-YguW__invertLayout",
  "left": "bento-rectangle-module-scss-module__S-YguW__left",
  "media": "bento-rectangle-module-scss-module__S-YguW__media",
  "right": "bento-rectangle-module-scss-module__S-YguW__right",
  "subtitle": "bento-rectangle-module-scss-module__S-YguW__subtitle",
  "vertical": "bento-rectangle-module-scss-module__S-YguW__vertical",
  "winnersBadge": "bento-rectangle-module-scss-module__S-YguW__winnersBadge",
});
